import { useEffect, useState } from "react";
import { useApi } from "utils";
import { ListType } from "../types";
import { SuccessFetch } from "types";

export function useList({ yearMonth, location_id }: { yearMonth: string, location_id: string | undefined }) {
    const api = useApi();

    const [data, setData] = useState<ListType | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    const params: Record<string, string | number> = {
        year_month: yearMonth,
    };

    if (location_id) {
        params.location_id = location_id;
    }

    const fetchUrl = () => {
        return api.get(`/sales_dashboard/sales_dashboard`, { params })
    }

    const fetchData = () => {
        setLoading(true);
        fetchUrl().then((res: SuccessFetch<{
            payload: ListType
        }>) => {
            setData(res.data.payload);
            setLoading(false);
        }).catch(() => {
            setData(null);
            setLoading(false);
        })
    }

    useEffect(() => {
        fetchData();
        return () => {
            setData(null);
            setLoading(false);
        }
        // eslint-disable-next-line
    }, [yearMonth, location_id]);
    return { fetchData, data, loading }

}